import ReactDOM from 'react-dom/client'
import { App } from '@core/routes'
import '@core/assets/css/global.css'

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
